export default __webpack_public_path__ + "static/media/cybslogo.c6fcf828.png";